import React, { useContext } from 'react';

import MyLocationIcon from '@mui/icons-material/MyLocation';
import { Button, Tooltip } from '@mui/material';
import { nanoid } from 'nanoid';
import { MapDataContext } from '../context/map-data';
import { MapLocation } from '../core/global';
import { isNumber } from '../helpers/core';
import { convertPolygonToBounds } from './locations-list';


interface PanToProps {
  lat?: number | string | null
  lon?: number | string | null
  centroid?: string | null
  bounds?: string | null
  size?: "small" | "medium" | "large"
  onClick?: () => void
  disabled?: boolean
}

export const PanToLocationButton = ({
  lat, 
  lon,
  centroid,
  bounds,
  size,
  onClick,
  disabled = false
}: PanToProps) => {
  
  const {
    setMapCenter,
  } = useContext(MapDataContext);

  return (
    <Tooltip
      title={'Pan to location'} 
      placement="bottom" 
      arrow
    >
      <span>
        <Button
          sx={{
            pl: 0,
            pr: 0,
            minWidth: size === "small" ? "34px" :"42px",
          }}
          disabled={disabled}
          size="small"
          variant='contained'
          color="success"
          onClick={(e: React.SyntheticEvent) => {
            e.preventDefault()
            e.stopPropagation();
            let centerPoint: MapLocation | null = null
            if (isNumber(lat) && isNumber(lon)) {
              centerPoint = {location: {lat, lng: lon}}
            } else if (centroid && typeof centroid === 'string') {
              const [lat, lng] = centroid.split(' ')
              centerPoint = {location: {lat, lng}}
            }
            if (bounds) {
              const converted = convertPolygonToBounds(bounds)
              if (converted && centerPoint) {
                centerPoint = {
                  ...centerPoint,
                  bounds: {...converted}
                }
              }
            }
            if (centerPoint) {
              setMapCenter({...centerPoint, hash: nanoid()})
            }
            
            if (onClick) {
              onClick()
            }
          }}
        >
          <MyLocationIcon  sx={{color: '#fff'}} />
        </Button>
        </span>
      </Tooltip>
  )
}
